import styled from 'styled-components';

import { UnstyledButton } from 'components/unstyled-button';

export const IconButton = styled(UnstyledButton)`
  margin-block-start: 0.3rem;
  padding: 0;
`;

export const Wrapper = styled.div`
  padding: 0 10px;
  && button {
    padding: 0;
    width: 44px;
    height: 44px;
  }
`;
